import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "user-info-container"
};
const _hoisted_2 = {
  class: "base-info-container"
};
const _hoisted_3 = {
  class: "title-container"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  key: 0,
  class: "subtitle"
};
const _hoisted_6 = {
  class: "subtitle"
};
const _hoisted_7 = {
  class: "subtitle"
};
const _hoisted_8 = {
  class: "operation-container"
};
const _hoisted_9 = {
  key: 0,
  class: "order-container"
};
const _hoisted_10 = {
  key: 1,
  class: "order-container"
};
import { computed, onMounted, watch, ref } from 'vue';
import { ElButton, ElImage, ElMessage } from 'element-plus';
import { calculateMD5, compressImage, getPosition, isUserType, uploadFile } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { isOpenDrawer } from "@/theme/drawerStyle";
import PendingOrder from "@/components/Account/PendingOrder.vue";
export default {
  __name: 'UserInfoBox',
  emits: ['updateUser', 'logout'],

  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit; // refs

    const avatarInput = ref(null);
    const pendingOrders = ref([]); // computed

    const user = computed(() => store.state.user);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const roleArray = computed(() => store.state.role_array ?? []);
    const wealthPoint = computed(() => {
      return (roleArray.value.reduce((sum, r) => sum + parseFloat(r.wealth_point || 0) * 10, 0) / 10).toFixed(1);
    });
    const organization = computed(() => {
      if (!user.value || !user.value.organization) return null;
      const org = user.value.organization;
      return `${org.id.toString().padStart(3, '0')} - ${org.name}`;
    }); // functions

    const getOrdersData = () => {
      if (isUserType(userType.value)) {
        request('transaction/role_transaction/list/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code !== 0) {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
            return;
          }

          pendingOrders.value = response.data;
        });
      }
    };

    const handleInputChange = event => {
      let file = event.target.files[0];

      if (file) {
        try {
          compressImage(file, 512 * 1024, compressedFile => {
            calculateMD5(compressedFile, async md5Value => {
              const fileResponse = await uploadFile(file, md5Value, {
                'path': 'user_avatar'
              });

              if (fileResponse.code !== 0) {
                ElMessage.error({
                  message: fileResponse.msg,
                  duration: 1500
                });
                return;
              }

              const updateResponse = await request('user/update/', {
                'updates': {
                  'avatar': fileResponse.data.file_id
                }
              }, 'POST');

              if (updateResponse.code !== 0) {
                ElMessage.error({
                  message: updateResponse.msg,
                  duration: 1500
                });
                return;
              }

              emits('updateUser');
              ElMessage.success({
                message: '信息更新完成',
                duration: 1500
              });
            });
          });
        } finally {
          avatarInput.value.value = null;
        }
      }
    };

    const clickAvatar = () => {
      avatarInput.value?.click();
    }; // lifecycle


    onMounted(() => {
      getOrdersData();
    }); // watcher

    watch(() => isOpenDrawer.value, newVal => {
      if (newVal) {
        getOrdersData();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "avatarInput",
        ref: avatarInput,
        onChange: handleInputChange
      }, null, 544), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElImage), {
        src: user.value?.avatar,
        fit: "cover",
        draggable: "false",
        onClick: _cache[0] || (_cache[0] = $event => clickAvatar())
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("text", _hoisted_4, [_createElementVNode("b", null, _toDisplayString(user.value?.nickname), 1), _createTextVNode("  " + _toDisplayString(`<${_unref(getPosition)(user.value?.user_type ?? 4)}>`), 1)]), organization.value ? (_openBlock(), _createElementBlock("text", _hoisted_5, "所属结社：" + _toDisplayString(organization.value), 1)) : _createCommentVNode("", true), _createElementVNode("text", _hoisted_6, "持有角色：" + _toDisplayString(roleArray.value.length) + " / " + _toDisplayString(user.value?.roles_numbers), 1), _createElementVNode("text", _hoisted_7, "资产点数：" + _toDisplayString(wealthPoint.value), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(ElButton), {
        class: "logout",
        onClick: _cache[1] || (_cache[1] = $event => emits('logout'))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("退出登录", -1)]))]),
        _: 1
      })]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), pendingOrders.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingOrders.value, (item, index) => {
        return _openBlock(), _createBlock(PendingOrder, {
          key: index,
          order: item,
          onUpdate: getOrdersData
        }, null, 8, ["order"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
        style: {
          "display": "flex",
          "height": "96px"
        }
      }, [_createElementVNode("text", {
        class: "empty-data-tips"
      }, "未检测到贸易订单")], -1)]))]))]);
    };
  }

};